<template>
  <section
    class="table-btn-box"
    :style="{ 'text-align': isCenter ? 'center' : ( newTableData.ctrlBtnList.length <= maxLength ? 'center' : '') }"
  >
    <span class="table-btn" v-for="(btnItem, btnIndex) in newTableData.ctrlBtnList" :key="btnIndex">
      <span
        :style="btnItem.style"
        class="primary cur"
        @click="btnItem.event"
        v-if="btnItem.isShowBtn"
      >
        {{
        btnItem.name
        }}
      </span>
    </span>

    <template permpisions v-if="newTableData.ctrlMoreBtnList.length">
      <el-dropdown class="table-btn">
        <span class="el-dropdown-link cur primary">
          <i class="iconfont">&#xe609;</i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <span v-for="(btnItem, btnIndex) in newTableData.ctrlMoreBtnList" :key="btnIndex">
            <el-dropdown-item @click.native="btnItem.event" v-if="btnItem.isShowBtn">
              <span :style="btnItem.style">{{ btnItem.name }}</span>
            </el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </section>
</template>

<script>
export default {
  props: {
    // 默认超过 2 个就使用下拉的模式展示
    maxLength: {
      type: Number,
      default: 2,
    },
    tableData: {
      type: Object,
      default: () => ({}),
    },
    btnList: {
      type: Array,
      default: () => ([]),
    },
    isShowDropdown: {
      type: Boolean,
      default: true,
    },
    isCenter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    newTableData () {
      let tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.ctrlBtnList = [];
      tableData.ctrlMoreBtnList = [];

      for (let i = 0; i < this.btnList.length; i++) {
        let showCondition = this.btnList[i].showCondition;
        if (showCondition === undefined) {
          // 如果没有填该属性，默认就是显示
          showCondition = true;
        }

        // 按钮权限验证
        const isShowBtn = this.checkPermpisions(this.btnList[i].permpisions);

        if (showCondition && isShowBtn) {
          // 只有同时满足了 显示条件判断 以及 按钮权限验证 ，这个按钮才可以显示出来
          tableData.ctrlBtnList.push({
            style: this.btnList[i].style,
            name: this.btnList[i].name,
            event: this.btnList[i].event,
            isShowBtn,
          });
        }
      }

      if (this.isShowDropdown) {
        if (tableData.ctrlBtnList.length > this.maxLength) {
          const length = tableData.ctrlBtnList.length - this.maxLength;
          tableData.ctrlMoreBtnList = tableData.ctrlBtnList.splice(this.maxLength, length);
        }
      }
      return tableData;
    },
  },
};
</script>

<style scoped lang="scss">
.table-btn-box {
  .table-btn {
    margin-left: 12px;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
